import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import Config from '../../static/config.json'

Vue.use(Vuex)

let latestVersion = 4
let defaultState = {
    version: latestVersion,
    warehouse: null,
    token: null,
    user: null,
    cart: {
        items: []
    },
    cartItemID: 1,
    categories: [],
    baseUrl: Config.baseUrl
    // config: Config
}

// This stores variables into the client browser.
export default new Vuex.Store({
    strict: true,
    plugins: [
        createPersistedState()
    ],
    state: defaultState,
    getters: {
        version: state => state.version,
        cart: state => state.cart,
        warehouse: state => state.warehouse,
        user: state => state.user,
        categories: state => state.categories,
        token: state => state.token,
        baseUrl: state => state.baseUrl
        // config: state => state.config
    },
    mutations: {
        setToken (state, token) {
            state.token = token
        },
        setUser (state, user) {
            if (user === null) {
                state.version = defaultState.version
                state.warehouse = defaultState.warehouse
                state.token = defaultState.token
                state.cart = defaultState.cart
                state.cartItemID = defaultState.cartItemID
                state.categories = defaultState.categories
                // state.config = Config
            }
            state.user = user
        },
        setCart (state, cart) {
            state.cart = cart
        },
        setWarehouse (state, warehouse) {
            state.warehouse = warehouse
        },

        removeCartItem (state, cartItemID) {
            let index
            let cartItems = state.cart.items
            for (index = 0; index < cartItems.length; index++) {
                if (cartItems[index].cartItemID === cartItemID) {
                    cartItems.splice(index, 1)
                }
            }
        },
        addCartItem (state, item) {
            item.cartId = state.cartItemID
            state.cart.items.push(item)
        },
        updateCartItemAmount (state, insertedItem) {
            let amount = insertedItem.updatedAmount
            let itemToUpdate = state.cart.items.find(item => { return item.itemID === insertedItem.itemID })
            if (itemToUpdate && !Number.isNaN(amount)) {
                itemToUpdate.amount = amount
            }
        },
        incrementCartItemID (state) {
            state.cartItemID++
        },
        setCategories (state, categories) {
            state.categories = categories
        },
        checkVersion (state) {
            state.baseUrl = Config.baseUrl
            if (!state.version || state.version < latestVersion) {
                state.version = defaultState.version
                state.warehouse = defaultState.warehouse
                state.token = defaultState.token
                state.user = defaultState.user
                state.cart = defaultState.cart
                state.cartItemID = defaultState.cartItemID
                state.categories = defaultState.categories
                // state.config = Config
            }
        }
    },
    actions: {
        setToken ({commit}, token) {
            commit('setToken', token)
        },
        setUser ({commit}, user) {
            commit('setUser', user)
        },
        setCart ({commit}, cart) {
            commit('setCart', cart)
        },
        setWarehouse ({commit}, warehouse) {
            commit('setWarehouse', warehouse)
        },
        removeCartItem ({commit}, cartItemID) {
            commit('removeCartItem', cartItemID)
        },
        addCartItem ({commit}, item) {
            commit('addCartItem', item)
        },
        updateCartItemAmount ({commit}, item) {
            commit('updateCartItemAmount', item)
        },
        incrementCartItemID ({commit}) {
            commit('incrementCartItemID')
        },
        setCategories ({commit}, categories) {
            commit('setCategories', categories)
        },
        checkVersion ({commit}) {
            commit('checkVersion')
        },
        setConfig ({commit}, config) {
            commit('setConfig', config)
        }
    }
})



// WEBPACK FOOTER //
// ./src/store/store.js